<template>
  <section class="is-small">
    <ui-page-hero title="Configuration" />

    <ChannelSettings />
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    ChannelSettings: () => import('@/components/Channels/ChannelSettings'),
  },

  props: {},

  data() {
    return {}
  },

  computed: {},

  created() { },

  methods: {},
}
</script>

<style></style>
